module.exports = __webpack_public_path__ + "static/media/default-background.5e7ec01b.jpeg";